import React from "react";
import {
  GraduationCap,
  BookOpen,
  Video,
  Users,
  Award,
  BarChart,
  Brain,
  Smartphone,
} from "lucide-react";
import IndustryPageTemplate from "../components/IndustryPageTemplate";

const SERVICE_OFFERINGS = [
  {
    title: "Learning Management Systems",
    description:
      "Build comprehensive LMS platforms for course delivery and tracking",
    icon: BookOpen,
  },
  {
    title: "Virtual Classrooms",
    description: "Develop live video learning with interactive features",
    icon: Video,
  },
  {
    title: "Student Portals",
    description:
      "Create self-service portals for enrollment and progress tracking",
    icon: Users,
  },
  {
    title: "Assessment & Testing",
    description: "Build online examination and certification systems",
    icon: Award,
  },
  {
    title: "Adaptive Learning",
    description: "AI-powered personalized learning paths and recommendations",
    icon: Brain,
  },
  {
    title: "Mobile Learning Apps",
    description: "Native apps for learning on-the-go",
    icon: Smartphone,
  },
  {
    title: "Analytics & Reporting",
    description: "Track learner progress and institutional performance",
    icon: BarChart,
  },
  {
    title: "Content Management",
    description: "Develop course authoring and content delivery tools",
    icon: GraduationCap,
  },
];

const STATS = [
  { value: "5M+", label: "Learners" },
  { value: "100+", label: "EdTech Apps" },
  { value: "50K+", label: "Courses Hosted" },
  { value: "95%", label: "Completion Rate" },
];

const EdTechIndustryPage = () => {
  return (
    <IndustryPageTemplate
      industrySlug="edtech-education-training"
      industryTitle="EdTech"
      industrySubtitle="& Education"
      heroDescription="Transforming education with innovative learning management systems, virtual classrooms, and training platforms that make quality education accessible to everyone."
      themeColor="#0ea5e9"
      themeColorLight="#38bdf8"
      themeGradient="linear-gradient(135deg, #0c4a6e 0%, #0369a1 50%, #0ea5e9 100%)"
      HeroIcon={GraduationCap}
      stats={STATS}
      serviceOfferings={SERVICE_OFFERINGS}
      heroImage={
        "https://images.unsplash.com/photo-1588934867842-39b70669d9b3?q=80&w=1170&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D"
      }
    />
  );
};

export default EdTechIndustryPage;
